import { useFragmentsDeliveryAPIStationConfigClientGetConfig } from '@mi-front/api-clients';
import { Info, QueryView } from '@mi-front/ui';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Alert } from '@mui/material';
import { useFragment } from '../../../hooks/useFragment';
import { DeliveryStatusInfo } from './DeliveryStatusInfo';

import { FormattedMessage } from 'react-intl';

export function FragmentDeliveryStatus() {
  const { fragment } = useFragment();

  const configQuery = useFragmentsDeliveryAPIStationConfigClientGetConfig(fragment.stationId);

  return (
    <Info
      title={
        <>
          <FileUploadIcon />{' '}
          <FormattedMessage id="fragments.exportStatus.title" defaultMessage="External export" />
        </>
      }
      data={
        <QueryView
          query={configQuery}
          children={(data) => {
            return !data?.enabled ? (
              <div>
                <Alert severity="warning">
                  <FormattedMessage
                    id="fragments.exportStatus.externalExportNotEnabled"
                    defaultMessage="El export externo no está habilitado, contacte a soporte."
                  />
                </Alert>
              </div>
            ) : (
              <DeliveryStatusInfo />
            );
          }}
        />
      }
    />
  );
}
